import React from 'react'
import { ReactComponent as ArrowUnfoldSvg} from '../../assets/svgs/arrows/Arrow_Unfold.svg';

const ArrowUnfoldIcon = () => (
    <div>
        <ArrowUnfoldSvg/>
    </div>
)

export default ArrowUnfoldIcon